/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const ADD_DONATION_ITEM = 'MFE/CHECKOUT/DONATION/ADD_DONATION_ITEM';
export const ADD_DONATION_ITEM_ERROR = 'MFE/CHECKOUT/DONATION/ADD_DONATION_ITEM_ERROR';
